import React, { useState } from 'react'
import { Modal, Box, Typography, Button } from '@mui/material'

import logo from '../../assets/camp_demo_logo.png'

export const PrototypeWarningModal = (): JSX.Element => {
  const [consent, setCosent] = useState<false | true>(false)

  return (
    <Modal
      open={!consent}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '36rem',
        boxShadow: 24,
        backgroundColor: '#0B2C4D',
        p: 4,
        borderRadius: '10px',
        textAlign: 'center',
      }}>
        <img src={logo as string} width='143px'/>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        This is CAMP DEMO
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        The 10,000 USDT given to you is fake! fee free to use it :)
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        You can try 6 easy steps and submit for 500 CAMP lucky draw!!
        </Typography>
        <Button
          variant="contained"
          sx={{ margin: '2rem', textTransform: 'capitalize' }}
          onClick= {()=> {
            localStorage.setItem('show-demo-popup', 'true')
            setCosent(!consent)
          }}>
          <Typography>I love CAMP demo</Typography>
        </Button>
      </Box>
    </Modal>
  )
}
